import Request from './authorized-request';
import Axios from 'axios';

let cancelToken = null;

export default class ManualsApi {

  static async fetch(options) {
    if (cancelToken) {
      cancelToken.cancel();
      cancelToken = null;
    }

    cancelToken = Axios.CancelToken.source()

    return Request.get('/models', {
      params: {
        ...options,
      },
      cancelToken: cancelToken.token,
    });
  }

  static async getConfig() {
    return Request.get('/models/config');
  }

  static async fetchOne(id) {
    return Request.get(`/models/${id}`);
  }

  static async update(data) {
    return Request.put(`/c/models/${data.id}`, data);
  }

  static async remove(data) {
    return Request.delete(`/c/models/${data.id}`);
  }

  static async create(data) {
    return Request.post(`/c/models`, data);
  }
}
